/**
 * Search Helpers for Car Data
 * Optimized for searching large datasets without memory leaks
 */

/**
 * Detect if text contains Arabic characters
 */
export function isArabicText(text) {
  if (!text || typeof text !== 'string') return false;
  var arabicPattern = /[\u0600-\u06FF]/;
  return arabicPattern.test(text);
}

/**
 * Normalize search term for better matching
 */
export function normalizeSearchTerm(term) {
  // Ensure term is a string
  if (!term || typeof term !== 'string') return "";
  return term.toLowerCase().trim();
}

/**
 * Check if item matches search term
 * Searches in both name (localized) and seo_url (English) fields
 */
export function matchesSearchTerm(item, searchTerm) {
  // Ensure searchTerm is a string
  if (!searchTerm || typeof searchTerm !== 'string') return true;
  var normalizedTerm = normalizeSearchTerm(searchTerm);
  if (!normalizedTerm) return true; // Empty search matches all

  var isArabic = isArabicText(searchTerm);

  // Ensure item.name exists and is a string
  var itemName = (item === null || item === void 0 ? void 0 : item.name) || '';

  // Arabic search - search in name field
  if (isArabic) {
    return itemName.toLowerCase().includes(normalizedTerm);
  }

  // English search - search in seo_url or seo_name field
  var seoField = item.seo_url || item.seo_name || '';
  return seoField.toLowerCase().includes(normalizedTerm);
}

/**
 * Generic search function for any array of items
 * @param items - Array to search
 * @param searchTerm - Search query
 * @param limit - Maximum number of results (default: 20)
 * @returns Filtered array
 */
export function searchItems(items, searchTerm) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
  // Handle invalid inputs
  if (!items || items.length === 0) {
    return [];
  }

  // If searchTerm is not a string or is empty, return limited items
  if (!searchTerm || typeof searchTerm !== 'string') {
    return items.slice(0, limit);
  }
  var results = [];
  var normalizedTerm = normalizeSearchTerm(searchTerm);

  // Early exit if normalized term is empty
  if (!normalizedTerm) {
    return items.slice(0, limit);
  }

  // Iterate and collect matches up to limit
  for (var i = 0; i < items.length && results.length < limit; i++) {
    if (matchesSearchTerm(items[i], searchTerm)) {
      results.push(items[i]);
    }
  }
  return results;
}